//HOME
export const SET_FIRST_USE = "SET_FIRST_USE";
export const LOAD_WALLET_NAME = "LOAD_WALLET_NAME";
export const LOAD_TOTAL_AMOUNT = "LOAD_TOTAL_AMOUNT";
export const SET_ANCHOR_EL = "SET_ANCHOR_EL";
export const SET_OPEN_DIALOG = "SET_OPEN_DIALOG";
export const SET_MODIFY_OPEN_DIALOG = "SET_MODIFY_OPEN_DIALOG";
export const SET_TOTAL_AMOUNT = "SET_TOTAL_AMOUNT";
export const SET_NEW_NAME = "SET_NEW_NAME";
export const SET_RENAME_DIALOG = "SET_RENAME_DIALOG";
export const SET_SNACKBAR_OPEN = "SET_SNACKBAR_OPEN";

//HISTORY
export const PUSH_RECORD = "PUSH_RECORD";

//LOGIN
export const INITIALIZE_LOGIN = "INITIALIZE_LOGIN";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_LOGIN_EMAIL = "SET_LOGIN_EMAIL";
export const SET_LOGIN_PASSWORD = "SET_LOGIN_PASSWORD";

//SIGNUP
export const INITIALIZE_SIGNUP = "INITIALIZE_SIGNUP";
export const SET_SIGNUP_ERROR = "SET_SIGNUP_ERROR";
export const SET_SIGNUP_USERNAME = "SET_SIGNUP_USERNAME";
export const SET_SIGNUP_EMAIL = "SET_SIGNUP_EMAIL";
export const SET_SIGNUP_PASSWORD1 = "SET_SIGNUP_PASSWORD1";
export const SET_SIGNUP_PASSWORD2 = "SET_SIGNUP_PASSWORD2";

//LANGUAGE
export const SET_LANGUAGE = "SET_LANGUAGE";


// WEBPACK FOOTER //
// ./src/constants/action_types.js